import {reactive} from 'vue'
// DataCube event handlers

import Utils from '../stuff/utils.js'
import Icons from '../stuff/icons.json'
import WebWork from './script_ww_api.js'
import Dataset from './dataset.js'


export default class DCEvents {

    constructor() {

        this.ww = new WebWork(this)
        this._loadingTimers = {}

        this.ww.onerror = e => {
            console.warn('[DataCube] Script worker error:', e && (e.message || e))
            this.ww._data_uploading = false
            this.set_loading(false)
        }

        // Listen to the web-worker events
        this.ww.onevent = e => {
            for (var ctrl of this.tv.controllers) {
                if (ctrl.ww) ctrl.ww(e.data)
            }
            switch(e.data.type) {
                case 'request-data':
                    // TODO: DataTunnel class for smarter data transfer
                    if (this.ww._data_uploading) break
                    let data = Dataset.make_tx(this, e.data.data)
                    this.send_meta_2_ww()
                    this.ww.just('upload-data', data)
                    this.ww._data_uploading = true
                    this.mark_data_uploading()
                    break
                case 'overlay-data':
                    this.on_overlay_data(e.data.data)
                    break
                case 'overlay-update':
                    this.on_overlay_update(e.data.data)
                    break
                case 'data-uploaded':
                    this.ww._data_uploading = false
                    this.clear_loading_guard('data-upload')
                    break
                case 'engine-state':
                    this.se_state = Object.assign(
                        this.se_state || {}, e.data.data)
                    break
                case 'modify-overlay':
                    this.modify_overlay(e.data.data)
                    break
                case 'script-signal':
                    this.tv.$emit('signal', e.data.data)
                    break
            }
            for (var ctrl of this.tv.controllers) {
                if (ctrl.post_ww) ctrl.post_ww(e.data)
            }
        }
    }

    // Called when overalay/tv emits 'custom-event'
    on_custom_event(event, args) {
        switch(event) {
            case 'register-tools': this.register_tools(args)
                break
            case 'exec-script': this.exec_script(args)
                break
            case 'exec-all-scripts': this.exec_all_scripts()
                break
            case 'data-len-changed': this.data_changed(args)
                break
            case 'tool-selected':
                if (!args[0]) break // TODO: Quick fix, investigate
                if (args[0].split(':')[0] === 'System') {
                    this.system_tool(args[0].split(':')[1])
                    break
                }
                this.tv.$set(this.data, 'tool', args[0])
                if (args[0] === 'Cursor') {
                    this.drawing_mode_off()
                }
                break
            case 'grid-mousedown': this.grid_mousedown(args)
                break
            case 'drawing-zoom':
                if(args[0][0]!==args[1][0])this.tv.setRange(Math.min(args[0][0],args[1][0]),Math.max(args[0][0],args[1][0]));
                this.system_tool('Remove');
                break
            case 'drawing-mode-off': this.drawing_mode_off()
                break
            case 'change-settings': this.change_settings(args)
                break
            case 'range-changed': this.scripts_onrange(...args)
                break
            case 'scroll-lock': this.on_scroll_lock(args[0])
                break
            case 'object-selected': this.object_selected(args)
                break
            case 'remove-tool': this.system_tool('Remove')
                break
            case 'before-destroy': this.before_destroy()
                break

        }

    }

    // Triggered when one or multiple settings are changed
    // We select only the changed ones & re-exec them on the
    // web worker
    on_settings(values, prev) {

        if (!this.sett.scripts) return

        let delta = {}
        let changed = false

        for (var i = 0; i < values.length; i++) {
            let n = values[i]
            let arr = prev.filter(x => x.v === n.v)
            if (!arr.length && n.p.settings.$props) {
                let id = n.p.settings.$uuid
                if (Utils.is_scr_props_upd(n, prev)) {
                    delta[id] = n.v
                    changed = true
                    this.tv.$set(n.p, 'loading', true)
                    this.mark_loading(n.p)
                }
            }
        }

        if (changed && Object.keys(delta).length) {
            let tf = (this.tv.$refs.chart && this.tv.$refs.chart.interval_ms) ||
                     this.data.chart.tf
            let range = this.tv.getRange()
            this.ww.just('update-ov-settings', {
                delta, tf, range
            })
        }

    }

    // When the set of $uuids is changed
    on_ids_changed(values, prev) {

        let rem = prev.filter(
            x => x !== undefined && !values.includes(x))

        if (rem.length) {
            this.ww.just('remove-scripts', rem)
            this.get('.').filter(overlay => rem.includes(overlay.settings.$synth)).forEach(overlay => this.del(overlay.id))
        }
    }

    // Combine all tools and their mods
    register_tools(tools) {
        let preset = {}
        for (var tool of this.data.tools || []) {
             preset[tool.type] = tool
             delete tool.type
        }
        this.tv.$set(this.data, 'tools', [])
        let list = [{
            type: 'Cursor', name: 'Cursor', icon: Icons['cursor.png']
        }]
        for (var tool of tools) {
            var proto = Object.assign({}, tool.info)
            let type = tool.info.type || 'Default'
            proto.type = `${tool.use_for}:${type}`
            this.merge_presets(proto, preset[tool.use_for])
            this.merge_presets(proto, preset[proto.type])
            // Ensure group and category properties are preserved
            if (tool.info.group) proto.group = tool.info.group
            if (tool.info.category) proto.category = tool.info.category

            delete proto.mods
            list.push(proto)
            for (var mod in tool.info.mods) {
                var mp = Object.assign({}, proto)
                mp = Object.assign(mp, tool.info.mods[mod])
                mp.type = `${tool.use_for}:${mod}`
                // Ensure group and category properties are preserved for mods too
                if (tool.info.group) mp.group = tool.info.group
                if (tool.info.mods[mod].category) mp.category = tool.info.mods[mod].category
                this.merge_presets(mp, preset[tool.use_for])
                this.merge_presets(mp, preset[mp.type])
                list.push(mp)
            }
        }
        this.tv.$set(this.data, 'tools', list)
        this.tv.$set(this.data, 'tool', 'Cursor')
    }

    exec_script(args) {
        if (args.length && this.sett.scripts) {
            let obj = this.get_overlay(args[0])
            if (!obj || obj.scripts === false) return
            if (obj.script && obj.script.src) {
                args[0].src = obj.script.src // opt, override the src
            }
            // Parse script props & get the values from the ov
            // TODO: remove unnecessary script initializations
            let s = obj.settings
            let props = args[0].src.props || {}
            if (!s.$uuid) s.$uuid = `${obj.type}-${Utils.uuid2()}`
            args[0].uuid = s.$uuid
            args[0].sett = s
            for (var k in props || {}) {
                let proto = props[k]
                if (s[k] !== undefined) {
                    proto.val = s[k] // use the existing val
                    continue
                }
                if (proto.def === undefined) {
                    // TODO: add support of info / errors to the legend
                    console.error(
                        `Overlay ${obj.id}: script prop '${k}' ` +
                        `doesn't have a default value`)
                    return
                }
                proto.val = proto.def
                this.tv.$set(s, k, proto.def) // reactive defaults for titles and settings
            }
            // Remove old props (dropped by the current exec)
            if (s.$props) {
                for (var k in s) {
                    if (s.$props.includes(k) && !(k in props)) {
                        delete s[k]
                    }
                }
            }
            this.tv.$set(s, '$props', Object.keys(props))
            this.tv.$set(s, '$options', Object.entries(props).map(([key, prop]) => ({
                key, label: prop.text || key, default: prop.def,
                integer: prop.integer === true,
                type: prop.type || (typeof prop.def === 'number' ? 'number' : typeof prop.def === 'boolean' ? 'boolean' : 'text'),
                min: prop.min != null ? prop.min : /length|period|^fast$|^slow$|^smooth$|^signal$|^number$/.test(key) ? 1 : undefined, max: prop.max,
                step: prop.step || (Number.isInteger(prop.def) ? 1 : 0.01),
                choices: prop.choices || [],
            })))
            this.tv.$set(obj, 'loading', true)
            this.mark_loading(obj)
            let tf = (this.tv.$refs.chart && this.tv.$refs.chart.interval_ms) ||
                     this.data.chart.tf
            let range = this.tv.getRange()
            if (obj.script && obj.script.output != null) {
                args[0].output = obj.script.output
            }
            this.ww.just('exec-script', {
                s: args[0], tf, range
            })
        }
    }

    exec_all_scripts() {
        if (!this.sett.scripts) return
        this.set_loading(true)
        let tf = (this.tv.$refs.chart && this.tv.$refs.chart.interval_ms) ||
                 this.data.chart.tf
        let range = this.tv.getRange()
        let main = this.data.chart && this.data.chart.data
        if (Array.isArray(main) && main.length && !this.ww._data_uploading) {
            this.send_meta_2_ww()
            this.ww.just('upload-data', { ohlcv: main })
            this.ww._data_uploading = true
            this.mark_data_uploading()
        }
        this.ww.just('exec-all-scripts', { tf, range })
    }

    scripts_onrange(r) {
        if (!this.sett.scripts) return
        let delta = {}

        this.get('.').forEach(v => {
            if (v.script && v.script.execOnRange &&
                v.settings.$uuid) {
                // TODO: execInterrupt flag?
                if (Utils.delayed_exec(v)) {
                    delta[v.settings.$uuid] = v.settings
                }
            }
        })

        if (Object.keys(delta).length) {
            let tf = (this.tv.$refs.chart && this.tv.$refs.chart.interval_ms) ||
                     this.data.chart.tf
            let range = this.tv.getRange()
            this.ww.just('update-ov-settings', {
                delta, tf, range
            })
        }
    }

    // Overlay modification from WW
    modify_overlay(upd) {
        let obj = this.get_overlay(upd)
        if (obj) {
            for (var k in upd.fields || {}) {
                if (obj[k] !== null && upd.fields[k] !== null && typeof obj[k] === 'object' && typeof upd.fields[k] === 'object') {
                    this.merge(`${upd.uuid}.${k}`, upd.fields[k])
                } else {
                    this.tv.$set(obj, k, upd.fields[k])
                }
            }
        }
    }

    data_changed(args) {
        if (!this.sett.scripts) return
        if (this.sett.data_change_exec === false) return
        let main = this.data.chart.data
        if (this.ww._data_uploading) return
        if (!this.se_state.scripts) return
        this.send_meta_2_ww()
        this.ww.just('upload-data', { ohlcv: main })
        this.ww._data_uploading = true
        this.mark_data_uploading()
        this.set_loading(true)
    }

    set_loading(flag) {
        let skrr = this.get('.').filter(x => x.settings.$props)
        for (var s of skrr) {
            this.merge(`${s.id}`, { loading: flag })
            if (flag) {
                this.mark_loading(s)
            } else {
                this.clear_loading_guard(s.id)
            }
        }
    }

    mark_loading(obj) {
        if (!obj || !obj.id) return
        this.tv.$set(obj, 'loadingStartedAt', Utils.now())
        this.clear_loading_guard(obj.id)
        this._loadingTimers[obj.id] = setTimeout(() => {
            const current = this.get_one(`${obj.id}`)
            if (current && current.loading) {
                console.warn(`[DataCube] Clearing stale loading state for ${obj.id}`)
                this.tv.$set(current, 'loading', false)
            }
            this.clear_loading_guard(obj.id)
        }, 12000)
    }

    clear_loading_guard(id) {
        if (!id || !this._loadingTimers || !this._loadingTimers[id]) return
        clearTimeout(this._loadingTimers[id])
        delete this._loadingTimers[id]
    }

    mark_data_uploading() {
        const id = 'data-upload'
        this.clear_loading_guard(id)
        this._loadingTimers[id] = setTimeout(() => {
            if (this.ww) this.ww._data_uploading = false
            this.set_loading(false)
            console.warn('[DataCube] Clearing stale script data upload state')
            this.clear_loading_guard(id)
        }, 12000)
    }

    send_meta_2_ww() {
        if (!this.tv.$refs.chart) return
        let tf = (this.tv.$refs.chart && this.tv.$refs.chart.interval_ms) ||
                 this.data.chart.tf
        let range = this.tv.getRange()
        this.ww.just('send-meta-info', { tf, range })
    }

    merge_presets(proto, preset) {
        if (!preset) return
        for (var k in preset) {
            if (k === 'settings') {
                Object.assign(proto[k], preset[k])
            } else {
                proto[k] = preset[k]
            }
        }
    }

    grid_mousedown(args) {
        // TODO: tool state finished?
        this.object_selected([])
        // Remove the previous RangeTool
        let rem = () => this.get('RangeTool')
            .filter(x => x.settings.shiftMode)
            .forEach(x => this.del(x.id))
        if (this.data.tool && this.data.tool !== 'Cursor' &&
           !this.data.drawingMode) {
            // Prevent from "null" tools (tool created with HODL)
            if (args[1].type !== 'tap') {
                this.tv.$set(this.data, 'drawingMode', true)
                this.build_tool(args[0])
            } else {
                this.tv.showTheTip(
                    `<b>Hodl</b>+<b>Drug</b> to create, ` +
                    `<b>Tap</b> to finish a tool`
                )
            }
        } else if (this.sett.shift_measure && args[1].shiftKey) {
            rem()
            this.tv.$nextTick(() =>
                this.build_tool(args[0], 'RangeTool:ShiftMode'))
        } else {
            rem()
        }
    }

    drawing_mode_off() {
        this.tv.$set(this.data, 'drawingMode', false)
        if (!this.data.drawingPrefs?.keepDrawing) this.tv.$set(this.data, 'tool', 'Cursor')
    }

    // Place a new tool
    build_tool(grid_id, type) {

        let list = this.data.tools
        type = type || this.data.tool
        let proto = list.find(x => x.type === type)
        if (!proto) return
        let template={};
        try { template=JSON.parse(localStorage.getItem('tc_drawing_template:'+proto.name) || '{}') } catch (_) {}
        let sett = Object.assign({}, proto.settings || {}, template)
        let data = (proto.data || []).slice()

        if(!('legend' in sett)) sett.legend = false
        if(!('z-index' in sett)) sett['z-index'] = 100
        sett.$selected = true
        sett.$state = 'wip'

        let side = grid_id ? 'offchart' : 'onchart'
        let id = this.add(side, {
            name: proto.name,
            type: type.split(':')[0],
            settings: sett,
            data: data,
            grid: { id: grid_id }
        })

        sett.$uuid = `${id}-${Utils.now()}`

        this.tv.$set(this.data, 'selected', sett.$uuid)
        this.add_trash_icon()
    }

    // Remove selected / Remove all, etc
    system_tool(type) {
        const actions={MagnetOff:['magnet','off'],MagnetWeak:['magnet','weak'],MagnetStrong:['magnet','strong'],KeepDrawing:['keepDrawing'],LockDrawings:['locked'],HideDrawings:['hidden'],CursorCross:['cursor','cross'],CursorDot:['cursor','dot'],CursorArrow:['cursor','arrow'],CursorDemonstration:['cursor','demonstration'],CursorMagic:['cursor','magic'],CursorEraser:['cursor','eraser']};
        if(actions[type]){
            const [key,value]=actions[type],prefs={...(this.data.drawingPrefs || {})};
            prefs[key]=value ?? !prefs[key];this.tv.$set(this.data,'drawingPrefs',prefs);
            if(key==='cursor'){this.tv.$set(this.data,'tool','Cursor');this.tv.$set(this.data,'drawingMode',false)}return;
        }
        switch (type) {
            case 'Remove':
                if (this.data.selected) {
                    this.del(this.data.selected)
                    this.remove_trash_icon()
                    this.drawing_mode_off()
                    this.on_scroll_lock(false)
                    this.tv.$set(this.data, 'selected', null)
                }
                break
            case 'RemoveAll':
                this.remove_all_drawings()
                break
        }
    }

    // Apply new overlay settings
    change_settings(args) {
        let settings = args[0]
        delete settings.id
        let grid_id = args[1]
        this.merge(`${args[3]}.settings`, settings)
    }

    // Lock the scrolling mechanism
    on_scroll_lock(flag) {
        this.tv.$set(this.data, 'scrollLock', flag)
    }

    // When new object is selected / unselected
    object_selected(args) {
        var q = this.data.selected
        if (q) {
            // Check if current drawing is finished
            //let res = this.get_one(`${q}.settings`)
            //if (res && res.$state !== 'finished') return
            this.merge(`${q}.settings`, {
                $selected: false
            })
            this.remove_trash_icon()
        }
        this.tv.$set(this.data, 'selected', null)

        if (!args.length) return

        // Use the $uuid (args[3]) which matches the datacube query format.
        // args = [originalArray, grid_id, layer_id, $uuid]
        let uuid = args[3] || args[2]
        this.tv.$set(this.data, 'selected', uuid)
        this.merge(`${uuid}.settings`, {
            $selected: true
        })

        this.add_trash_icon()
    }

    add_trash_icon() {
        const type = 'System:Remove'
        if (this.data.tools.find(x => x.type === type)) {
            return
        }
        this.data.tools.push({
            type, icon: Icons['trash.png']
        })
    }

    remove_trash_icon() {
        // TODO: Does not call Toolbar render (distr version)
        const type = 'System:Remove'
        Utils.overwrite(this.data.tools,
            this.data.tools.filter(x => x.type !== type)
        )
    }

    // Remove all drawing overlays from the chart
    remove_all_drawings() {
        let isDrawing = x => x.settings && x.settings.$state === 'finished'
        // Collect UUIDs of all finished drawings for reliable deletion
        let toRemove = []
        ;(this.data.onchart || []).forEach((x) => {
            if (isDrawing(x) && x.settings.$uuid) {
                toRemove.push(x.settings.$uuid)
            }
        })
        ;(this.data.offchart || []).forEach((x) => {
            if (isDrawing(x) && x.settings.$uuid) {
                toRemove.push(x.settings.$uuid)
            }
        })
        // Delete each drawing by its UUID
        toRemove.forEach(uuid => this.del(uuid))
        this.remove_trash_icon()
        this.drawing_mode_off()
        this.on_scroll_lock(false)
        this.tv.$set(this.data, 'selected', null)
    }

    // Set overlay data from the web-worker
    on_overlay_data(data) {
        // A secondary timeframe sends a partial result set. Remove synthetic
        // children only for parents included in this result, preserving clouds
        // and lines owned by indicators calculated in another worker.
        const parents = new Set(data.map(overlay => overlay.id))
        this.get('.').forEach(x => {
            if (x.settings.$synth && parents.has(x.settings.$synth)) this.del(`${x.id}`)
        })
        for (var ov of data) {
            let obj = this.get_one(`${ov.id}`)
            if (obj) {
                // Worker callbacks can retain the raw DataCube instance. Mutate
                // through Vue's proxy so pane subsets invalidate on first output.
                obj=reactive(obj)
                this.tv.$set(obj, 'loading', false)
                this.clear_loading_guard(obj.id)
                if (!ov.data) continue
                obj.data = ov.data
            }
            if (!ov.new_ovs) continue
            for (var id in ov.new_ovs.onchart) {
                if (!this.get_one(`onchart.${id}`)) {
                    this.add('onchart', ov.new_ovs.onchart[id])
                }
            }
            for (var id in ov.new_ovs.offchart) {
                if (!this.get_one(`offchart.${id}`)) {
                    this.add('offchart', ov.new_ovs.offchart[id])
                }
            }
        }
    }

    // Push overlay updates from the web-worker
    on_overlay_update(data) {
        for (var ov of data) {
            if (!ov.data) continue
            let obj = this.get_one(`${ov.id}`)
            if (obj) {
                this.fast_merge(reactive(obj.data), ov.data, false)
            }
        }
    }

    // Clean-up unfinished business (tools)
    before_destroy() {
        for (var id in this._loadingTimers || {}) {
            this.clear_loading_guard(id)
        }
        let f = x => !x.settings.$state ||
            x.settings.$state === 'finished'
        this.data.onchart = this.data.onchart
            .filter(f)
        this.data.offchart = this.data.offchart
            .filter(f)
        this.drawing_mode_off()
        this.on_scroll_lock(false)
        this.object_selected([])
        if (this.agg) this.agg.stop()
        for (const unwatch of this._viewWatchers || []) unwatch()
        this._viewWatchers = []
        this.ww.destroy()
        this.tv = null
    }

    // Get overlay by grid-layer id
    get_overlay(obj) {
        let id = obj.id || `g${obj.grid_id}_${obj.layer_id}`
        let dcid = obj.uuid || this.gldc[id]
        return this.get_one(`${dcid}`)
    }


}
